module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/Temperature/Tokyo_Temperature_MRI_RCP85_End.png";